<div class="login-container m-auto hub-report-upload">
  <div class="card boxshadow">
    <div class="card-header bg-primary text-white d-flex justify-content-center align-items-center">
      <a class="btn" style="border: 1px solid; border-color: white;">LT Report Upload</a>
    </div>
    <div class="card-body">

      <!-- Reminder: current week not yet submitted -->
      <div class="alert" [ngClass]="reportUrgent ? 'alert-danger report-alert-flash' : 'alert-warning'" *ngIf="reportDue">
        <i class="fas fa-bell mr-1"></i>
        Your weekly report for <strong>{{ formatWeek(currentWeekEnding) }}</strong> has not been submitted yet.
      </div>

      <p>
        Upload the weekly report template exactly as provided. Do not rename or move the
        column headers, and keep the file in <strong>.csv</strong> format.
      </p>
      <p class="mb-1">You only fill in these columns &mdash; everything else is prefilled by Salesforce:</p>
      <ul class="hub-columns">
        <li *ngFor="let c of hubColumns">{{ c }}</li>
      </ul>

      <div class="form-group mt-3">
        <label for="weekEnding">Week ending</label>
        <select id="weekEnding" class="form-control" [(ngModel)]="selectedWeek" [disabled]="uploading">
          <option value="" disabled>Select week ending...</option>
          <option *ngFor="let w of weekOptions" [value]="w.value">{{ w.label }}</option>
        </select>
        <small class="form-text text-muted">
          The Week Ending in your file must match the week selected here.
        </small>
      </div>

      <div class="form-group">
        <label for="csvFile">Select CSV file</label>
        <div class="custom-file">
          <input type="file" class="custom-file-input" id="csvFile" accept=".csv"
                 (change)="onFileSelected($event)" [disabled]="uploading" />
          <label class="custom-file-label" for="csvFile">{{ fileName || 'Choose file...' }}</label>
        </div>
        <small class="text-danger" *ngIf="fileError">{{ fileError }}</small>
      </div>

      <button type="button" class="btn btn-primary" (click)="onUpload()"
              [disabled]="uploading || !base64Content || !selectedWeek">
        <span *ngIf="uploading" class="spinner-border spinner-border-sm mr-1"></span>
        {{ uploading ? 'Uploading...' : 'Upload' }}
      </button>
      <button type="button" class="btn btn-default ml-2" (click)="reset()" [disabled]="uploading">
        Clear
      </button>

      <!-- Detailed rejection list (the Swal popup shows the summary + first few) -->
      <div class="table-responsive mt-3"
           *ngIf="result && !result.success && result.errors && result.errors.length">
        <table class="table table-sm table-bordered">
          <thead>
            <tr>
              <th style="width:80px;">Row</th>
              <th style="width:180px;">Column</th>
              <th>Issue</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let e of result.errors">
              <td>{{ e.row !== null && e.row !== undefined ? e.row : 'File' }}</td>
              <td>{{ e.column || '—' }}</td>
              <td>{{ e.message }}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>
</div>
